export default "https://cdn-static.gokick.com/assets/9df01a4d731a00226137dd4d749df43ffc1d6e8e/images/choco-chill.d2e5a3cb4eac031c8a1d2dbef046a05a.png";